import { httpClient } from "../httpClient";

type Application = {
  id: number;
  name: string;
  host: string;
  type: string;
  accessDetailNote?: string;
  additionalForm?: string;
  categoryId: number;
  systemTypeId: number;
  uamNote?: string;
  formTemplate?: string;
  formTemplate2?: string;
  categoryType?: string;
  metadata?: string;
  mobileAttestation: boolean;
  singleRequest: boolean;
  revokeNeededForm: boolean;
  manual: boolean;
  lz: boolean;
};

export async function getApplications(): Promise<Application[]> {
  try {
    const { data } = await httpClient.get<{
      applications: Application[];
    }>(`/api/v1/applications`);

    return data.applications;
  } catch (error) {
    throw error;
  }
}

export const applications = {
  getApplications,
};
